import {
  Panel,
  TableRow,
  Button,
  ButtonSize,
  ButtonVariant,
} from "@/components";
import { SubcontractorItemProps } from "./types";
import { SubcontractorField, SubcontractorFieldLabel } from "../../edit/types";
import styles from "./styles.scss";

export const SubcontractorItem = ({
  subcontractor,
  onAddSubcontractor,
}: SubcontractorItemProps) => {
  return (
    <Panel panelInnerClassName={styles.subcontractorItemWrapper}>
      <TableRow
        label={SubcontractorFieldLabel.COMPANY_ID}
        value={subcontractor[SubcontractorField.COMPANY_ID]}
      />
      <TableRow
        label={SubcontractorFieldLabel.ARABIC_NAME}
        value={subcontractor[SubcontractorField.ARABIC_NAME]}
      />
      <TableRow
        label={SubcontractorFieldLabel.ENGLISH_NAME}
        value={subcontractor[SubcontractorField.ENGLISH_NAME]}
      />
      <TableRow
        value={
          <Button
            variant={ButtonVariant.Secondary}
            size={ButtonSize.Small}
            className={styles.addSubcontractorBtn}
            onClick={() => onAddSubcontractor(subcontractor)}
          >
            Add as a Subcontractor
          </Button>
        }
      />
    </Panel>
  );
};
